import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Ce composant va écouter les changements de page et remonter la fenêtre en haut
function ScrollToTop() {
  // useLocation nous donne des informations sur l'URL actuelle, notamment le chemin (pathname)
  const { pathname } = useLocation();

  // useEffect est un hook qui exécute une action après le rendu du composant.
  // En ajoutant [pathname] à la fin, on s'assure que l'action ne se déclenche
  // QUE lorsque le chemin de l'URL change.
  useEffect(() => {
    // Fait remonter la fenêtre en haut de page (coordonnées 0, 0)
    window.scrollTo(0, 0);
  }, [pathname]);

  // Ce composant n'a pas besoin d'afficher quoi que ce soit à l'écran
  return null;
}

export default ScrollToTop;